(function () {
  'use strict';

  function initSwiper(el) {
    if (!el) return;
    if (!window.Swiper) {
      setTimeout(function () { initSwiper(el); }, 100);
      return;
    }
    if (el.dataset.trendsInited === '1') return;
    el.dataset.trendsInited = '1';

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      grabCursor: true,
      a11y: {
        prevSlideMessage: 'Previous article',
        nextSlideMessage: 'Next article'
      },
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          spaceBetween: 0
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-trends-swiper]').forEach(initSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const el = e.target.querySelector('[data-trends-swiper]');
    if (el) initSwiper(el);
  });
})();
